import React from "react";

import useIsDesktop from "../../../hooks/useIsDesktop";
import PaymentBar from "./PaymentBar";
import PaymentBarCompacted from "./PaymentBarCompacted";
import useAvailablePaymentMethods from "../../../../../../hooks/useAvailablePaymentMethods";
import useSetDefaultPaymentMethod from "../../../../../../hooks/useSetDefaultPaymentMethod";

const PaymentBarWrapper = ({
  period,
  supportedPaymentMethods,
  currentCurrencyOfferByPeriod,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  selectedPlan,
  finalizePayment,
  paymentFormLoading,
  paymentDetails,
  paymentDetailsLoading
}) => {
  const isDesktop = useIsDesktop();

  const availablePaymentMethods = useAvailablePaymentMethods({
    currentCurrencyOfferByPeriod,
    supportedPaymentMethods
  });

  useSetDefaultPaymentMethod({
    setSelectedPaymentMethod,
    availablePaymentMethods,
    currentCurrencyOfferByPeriod,
    supportedPaymentMethods,
    period
  });

  return isDesktop ? (
    <PaymentBar
      period={period}
      availablePaymentMethods={availablePaymentMethods}
      currentCurrencyOfferByPeriod={currentCurrencyOfferByPeriod}
      selectedPaymentMethod={selectedPaymentMethod}
      setSelectedPaymentMethod={setSelectedPaymentMethod}
      selectedPlan={selectedPlan}
      finalizePayment={finalizePayment}
      paymentFormLoading={paymentFormLoading}
      paymentDetails={paymentDetails}
      paymentDetailsLoading={paymentDetailsLoading}
    />
  ) : (
    <PaymentBarCompacted
      period={period}
      availablePaymentMethods={availablePaymentMethods}
      currentCurrencyOfferByPeriod={currentCurrencyOfferByPeriod}
      selectedPaymentMethod={selectedPaymentMethod}
      setSelectedPaymentMethod={setSelectedPaymentMethod}
      selectedPlan={selectedPlan}
      finalizePayment={finalizePayment}
      paymentFormLoading={paymentFormLoading}
      paymentDetails={paymentDetails}
      paymentDetailsLoading={paymentDetailsLoading}
    />
  );
};

export default PaymentBarWrapper;
